function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowCircleLeftFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 31a15 15 0 100-30 15 15 0 000 30zM8.5 15.97a1.2 1.2 0 01.354-.87l4.938-4.923a1.208 1.208 0 111.71 1.707l-2.892 2.895h9.69a1.2 1.2 0 110 2.4h-9.717l2.919 2.919a1.21 1.21 0 11-1.71 1.71l-4.938-4.923a1.2 1.2 0 01-.354-.855v-.06z",
    fill: props.color
  }));
}

export default SvgIconArrowCircleLeftFilled;